import { UploadError } from './UploadError';

export class FileTooLargeError extends UploadError {
    radarName = 'error_{SOURCE}_file-too-large';
    message = 'Слишком большой файл.';
}
